export default function phoneRegExp(value) {
  const phone = value.replace(/\s+/g, '');

  return phone.replace(/[^\w\s]/g, '');
}

export const checkPlus = phone => (phone && phone.charAt(0) === '+' ? phone : `+${phone}`);
